// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MergeCellsOutlinedSvg from "@ant-design/icons-svg/es/asn/MergeCellsOutlined";
import AntdIcon from '../components/AntdIcon';

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MergeCellsOutlinedSvg
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
export default React.forwardRef(MergeCellsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MergeCellsOutlined.js
// module id = 1479
// module chunks = 0